import Wrapper from "../../layout/Wrapper";
import LegacyLifeBillEntry from "../../screens/legacyLifeEntry/bill";
import LegacyShell from "../../screens/legacyLifeEntry/shell";

export default function LegacyLifeBillEntryPage() {
  return (
    <Wrapper>
      <LegacyShell>
        <LegacyLifeBillEntry />
      </LegacyShell>
    </Wrapper>
  );
}
